import InOutBook from "../../slices/vms/inOutBook/InOutBook";
import InOutCount from "../../slices/vms/inOutCount/InOutCount";
import PreApprovedVisitor from "../../slices/vms/preApprovedVisitor/PreApprovedVisitor";
import VisitorApprovalRequest from "../../slices/vms/visitorApprovalRequest/VisitorApprovalRequest";
import MyVisitor from "../../slices/vms/myVisitor/MyVisitor";
import VisitorParking from "../../slices/vms/visitorParking/VisitorParking";
import OverStay from "../../slices/vms/overStay/OverStay";

const visitorReducer = {
    inOutBook: InOutBook,
    inOutCount: InOutCount,
    preApprovedVisitor: PreApprovedVisitor,
    visitorApprovalRequest: VisitorApprovalRequest,
    myVisitor: MyVisitor,
    visitorParking: VisitorParking,
    overStay: OverStay,
};

export default visitorReducer;